// extracted by mini-css-extract-plugin
module.exports = {"teamMember":"team-member-module--team-member--3Dxaa","photo":"team-member-module--photo--1ySsk"};